export default "__VITE_ASSET__DNbKjoRX__"